import {NgModule, ModuleWithProviders} from '@angular/core';
import {Platform} from './platform';


@NgModule({
  providers: [Platform]
})
export class PlatformModule {
  /** @deprecated */
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: PlatformModule,
      providers: [],
    };
  }
}


export * from './platform';
export * from './features';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/_core.md2/platform/index.ts